import React from 'react';
import PropTypes from 'prop-types';
import { forEach } from 'lodash';
import { em } from 'polished';
import { Field } from 'formik';
import styled from 'styled-components';
import { CheckboxWrapper } from '../form';

const SubFieldWrapper = styled.div`
  margin-left: ${em(50)};
`;

class CheckboxGroup extends React.Component {
  handleParentChange = e => {
    const { checkboxField, setFieldValue, values } = this.props;
    const subfieldIds = Object.keys(values);
    forEach(subfieldIds, function(subfieldId) {
      if (subfieldId === 'isIncluded') return;
      setFieldValue(`${checkboxField.id}.${subfieldId}`, e.target.checked);
    });
  };

  handleChildChange = e => {
    const { checkboxField, setFieldValue } = this.props;
    if (!e.target.checked) return;
    setFieldValue(`${checkboxField.id}.isIncluded`, true);
  };

  render() {
    const { checkboxField } = this.props;

    return (
      <React.Fragment>
        <Field
          component={CheckboxWrapper}
          id={checkboxField.id}
          key={checkboxField.id}
          label={checkboxField.label}
          name={`${checkboxField.id}.isIncluded`}
          onChange={this.handleParentChange}
        />
        {checkboxField.subfields.map(subfield => (
          <SubFieldWrapper key={subfield.id}>
            <Field
              component={CheckboxWrapper}
              id={`${checkboxField.id}.${subfield.id}`}
              key={subfield.id}
              label={subfield.label}
              name={`${checkboxField.id}.${subfield.id}`}
              onChange={this.handleChildChange}
            />
          </SubFieldWrapper>
        ))}
      </React.Fragment>
    );
  }
}

CheckboxGroup.propTypes = {
  checkboxField: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/modules/common/form/CheckboxGroup.js